import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { TagEditor } from './TagEditor';

const TagEditorBridge = react2angular(TagEditor, [
  'taggedEntityType',
  'selectedTagIds',
  'editable',
  'onSaved'
]);
export default TagEditorBridge;
